<template>
    <div>
        <div class="process-loading" v-if="process_loading">
            <div class="welcome">Добро пожаловать в</div>
            <Logo orange="true"></Logo>
        </div>

        <slot name="header">
            <Header></Header>

            <Basket v-if="isBasketOpen"></Basket>
        </slot>

        <slot name="content">
            <div class="container">
                <Catalog></Catalog>
            </div>
        </slot>

        <slot name="footer">
            <Map></Map>
            <Footer></Footer>
        </slot>

        <div v-if="send_order" class="process-order">
            <div class="pp-icon pp-icon-chief"></div>
            Завершение оформления заказа, пожалуйста подождите...
        </div>

        <div v-if="errorWithOnlineOrder" class="process-order">
            <div class="error-box">
                <div v-if="isOrderAlreadyInProcessing">
                  Ваш заказ уже находится в обработке.
                </div>
                <div v-else-if="isNotPaidOrder">
                  Ваш заказ не сохранен, т.к. нам не удалось получить оплату. Возможно вы ввели неверные данные карты или на вашем счету недостаточно средств.
                </div>
                <div v-else>
                  Произошла ошибка во время отправки заказа в пиццерию. Мы получили уведомление о данной ошибке и наш менеджер свяжется с вами в ближайшее время.
                </div>
                <div>Если у вас есть вопросы по вашему заказу вы можете позвонить нам по телефону {{ pizzeriaInfo.phone_full }}.</div>
                <div class="button-close" @click="errorWithOnlineOrder = false">Закрыть</div>
            </div>
        </div>

        <Cabinet v-if="isShowingCabinet" ></Cabinet>

        <div class="notification-box-modal color-white" v-show="showPizzaCloseModal">
            <div class="notification-box">
                <div class="notification-box-heading">
                    <img :src="require('@/assets/images/pizzeria-closed.png')" class="notification__image">
                    <div class="notification__title">{{phrases.TEXT_OVEN_REST}}</div>
                </div>
                <div class="notification-box-preorder-text">{{phrases.TEXT_DEFER_ORDER}}</div>
                <div class="notification-box-text">
                    {{ ["Pizza Prosto", phrases.TEXT_WORKS, phrases.TEXT_FROM, pizzeriaInfo.schedule.start+":00", phrases.TEXT_TO, pizzeriaInfo.schedule.finish+":00"].join(" ") }}
                </div>
                <div class="notification-box-footer">
                    <div class="mfp-close-button button button-black" @click="closePizzaCloseModal()">{{phrases.TEXT_BUTTON_CLOSE }}</div>
                </div>
            </div>
        </div>

        <ModalTemplate v-if="isOpenShareModal" on-close="catalog/setIsOpenShareModal"
                       box-class="notification-box-default">
          <template slot="header">
            <div class="notification-box-heading">
              <div class="notification__title">{{productShare.title}}</div>
            </div>
          </template>
          <template slot="body">
            <div class="notification-box-text">
              <div class="notification-box-preorder-text" v-html="productShare.description"></div>
            </div>
          </template>
        </ModalTemplate>

        <ModalTemplate v-if="showModalFreeDeliveryShareCondition" box-class="notification-box-default"
                       on-close="app/setShowModalFreeDeliveryShareCondition">
          <template slot="body">
              <div class="free-delivery-share-condition" v-html="free_delivery_share_condition"></div>
          </template>
        </ModalTemplate>

        <MobileAppBanner :banner="mobileAppBanner" v-if="showMobileAppBanner"></MobileAppBanner>

        <Modal v-if="showHandleCloseModal" :close-function-trigger="closeHandleCloseModal">
          <template slot="header">
            <img :src="require('@/assets/images/pizzeria-closed.png')" class="notification__image">
          </template>
          <template slot="body">
            <div class="notification-box-text">
              <div class="notification-box-preorder-text">{{pizzeriaInfo.hand_close.comment}}</div>
            </div>
          </template>
        </Modal>

        <div class="notification-box-modal color-white modal-change-location" v-show="changeLocation">
          <div class="notification-box">
            <div class="notification-box-heading">
              <div class="notification__title">{{phrases.TEXT_MODAL_LOCATION_TITLE}}</div>
            </div>
            <a v-for="pizzeria in pizzeria_list" :key="pizzeria.id" :href="pizzeria.url">
              <div class="notification-box-text location-city">
                {{pizzeria.name}}
              </div>
            </a>
            <div class="notification-box-footer">
              <div class="mfp-close-button button button-black" @click="setChangeLocation()">{{phrases.TEXT_BUTTON_CLOSE }}</div>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
    import Utils from "../Utils";
    import Basket from "../Basket";
    import {mapGetters} from "vuex";
    import Catalog from "../catalog/Catalog.vue";
    import Header from "../partial/header";
    import Footer from "../partial/footer";
    import Logo from "../partial/logo";
    import Map from "../partial/map";
    import Cabinet from "../cabinet/Cabinet";
    import Modal from "../partial/modal";
    import ModalTemplate from "../partial/modal-template";
    import {scroller, setDefaults} from 'vue-scrollto/src/scrollTo'
    import MobileAppBanner from "@/components/partial/mobile-app-modal.vue";
    import ComboUtils from "@/components/combos/ComboUtils.vue";
    setDefaults({offset: -100});
    const scrollerTo = scroller();
    const DEFAULT_CITY_CODE = "vl";
    const TRUDOVOE_CITY_CODE = "tr";
    const SITE_TRUDOVOE_DIRECTORY_PATH = "trudovoe";

    export default {
        name: "Home",
        data: function () {
            return {
                process_loading: true,
                send_order: false,
                errorWithOnlineOrder: false,
                isNotPaidOrder: false,
                isOrderAlreadyInProcessing: false,
                showModalPizzaClosed: true,
                timeOutId: 0,
                mobileAppBanner: null,
                showHandleCloseModal: false
            };
        },
        methods: {
            setDeviceSize(){
                const component = this;
                const isSizeMd = this.windowWidth < 991;
                clearTimeout(component.timeOutId);
                component.timeOutId = setTimeout(function (){
                  component.$store.commit('app/setIsSizeMd', isSizeMd);
                }, 500);
            },
            closePizzaCloseModal: function () {
                this.showModalPizzaClosed = false;
            },
            completeOrderWithOnlinePayment(){
                const component = this;
                return new Promise((resolve, reject) => {
                    const online_payment = component.$cookies.get(component.cookie_online_payment);
                    if (component.$route.query.payment_id !== undefined || online_payment !== null) {
                        component.$cookies.remove(this.cookie_online_payment);
                        let payment_id, order_id = 0;
                        if (online_payment !== null &&
                            online_payment['payment_id'] !== undefined && online_payment['order_id'] !== undefined) {
                          payment_id = online_payment['payment_id'];
                          order_id = online_payment['order_id'];
                        } else if (this.$route.query.payment_id !== undefined && this.$route.query.order_id) {
                          payment_id = this.$route.query.payment_id;
                          order_id = this.$route.query.order_id;
                        }
                        component.send_order = true;
                        component.sendRequest('complete-order', {
                          payment_id: payment_id,
                          order_id: order_id
                        }).then(response => {
                            component.send_order = false;
                            const data = response.data;
                            if (data.status === 'success') {
                                component.$store.dispatch({
                                  type: 'order/finishOnlinePayment', payment_id: payment_id, order: {
                                    id: data.order_id,
                                    payment_id: payment_id,
                                    status: data.order_status,
                                    dateDelivery: data.dateDelivery,
                                    delayTimeFrom: data.delayTimeFrom,
                                    delayTimeTo: data.delayTimeTo,
                                    is_paid: data.is_paid,
                                    number: data.number,
                                    created: true,
                                  },
                                }).then(function () {
                                  component.setConfirm();
                                  component.$store.commit('order/openBasket');
                                  component.$store.dispatch({
                                    type: 'order/setCheckout',
                                    state: true,
                                  });
                                  const new_order_id = data.order_id;
                                  component.$cookies.set('order', {id: new_order_id, payment_id: payment_id});
                                  component.checkOrderStatus(new_order_id, payment_id);
                                  resolve();
                                }).finally(function () {
                                  component.sendOrderToGoogleTagManager(data.order_id, component.order);
                                });
                            } else {
                                component.errorWithOnlineOrder = true;
                                if (data.status === 'error') {
                                  component.isNotPaidOrder = !data.is_paid;
                                } else if (data.status === 'processed') {
                                  component.isOrderAlreadyInProcessing = true;
                                } else if (data.status === 'skip') {
                                  component.isOrderAlreadyInProcessing = true;
                                }
                                reject("Error during process of online payment");
                            }
                        }).catch(error => {
                          reject(error);
                        });
                  } else {
                    resolve();
                  }
                });
            },
            activateCouponFromUrl: function (url){
              const component = this;
              const PROMO_CODE_TEMPLATE = "#promo-code-"
              const promoCode = url.search(PROMO_CODE_TEMPLATE) >= 0 ? url : null;
              if(promoCode !== null) {
                component.$store.commit('order/setCoupon', promoCode.replace(PROMO_CODE_TEMPLATE, ""));
                component.$store.commit('order/openBasket', true);
              }
            },
            applyComboFromRequest: async function (requests, combos){
                const component = this;
                if(requests['add-combo'] !== undefined){
                  const combo = combos.find(c => {
                    return c.entity_code === requests['add-combo'];
                  });
                  if(combo !== undefined){
                    const preparedCombo = component.buildComboBasketItem(combo,  component.collectDefaultComboItems(combo), 0);
                    await component.$store.dispatch('order/addToBasket', {offer: preparedCombo}).then(() => {
                      component.$store.commit('order/openBasket', true);
                    });
                  }
                }
            },
            defineLanguage: function (){
              let lang = 'ru';
              if(this.$route.query.lang !== undefined){
                lang = this.$route.query.lang;
                this.$cookies.set('app-lang', lang);
              }else if(this.$cookies.get('app-lang')){
                lang = this.$cookies.get('app-lang');
              }
              this.$cookies.set('app-lang', lang);
              return lang;
            },
            defineCityCode: function (){
              const location = window.location;
              const cityCode = location.hostname.split(".")[0];
              if(cityCode === "pizza-prosto"){
                return DEFAULT_CITY_CODE;
              }
              if(cityCode === DEFAULT_CITY_CODE && location.pathname.search(SITE_TRUDOVOE_DIRECTORY_PATH) >= 0){
                return this.checkDevMode(TRUDOVOE_CITY_CODE);
              }
              return this.checkDevMode(cityCode);
            },
            checkDevMode: function (cityCode){
              if(this.isDevMode || ['develop', 'main', 'localhost'].find(c => c === cityCode) !== undefined){
                const paramCityCode = this.$route.query.city;
                if(paramCityCode !== undefined && paramCityCode.length > 0){
                  return paramCityCode;
                }
                return DEFAULT_CITY_CODE;
              }
              return cityCode;
            },
            closeHandleCloseModal: function (){
              this.showHandleCloseModal = false;
            },
            getUtmId: function (requests){
              return requests['utm_id'] === undefined ? null : requests['utm_id'];
            }
        },
        mounted() {
            const component = this;
            if(process.env.VUE_APP_DEV_MODE === 'true'){
                this.$store.commit('app/setDevMode');
            }

            const lang = this.defineLanguage();
            const cityCode = this.defineCityCode();
            this.$store.commit('app/setCityCode', {code: cityCode, lang: lang});

            this.dropCookieIntervalTimer();
            this.checkUserAuth();

            component.sendRequest('load-app-info', {'code': cityCode, lang: lang, meta: {utm_id: component.getUtmId(component.$route.query)}}).then(response => {
                const data = response.data;
                const pizzeriaInfo = data.pizzeria;
                const isPizzeriaClosed = data.isPizzeriaClosed;

                component.$store.dispatch({
                    type: 'app/setInfo',
                    pizzeria: pizzeriaInfo,
                    phrases: data.phrases,
                    headerMenu: data.header_menu,
                    footerMenu: data.footer_menu,
                    banners: data.banners,
                    isPizzeriaClosed: isPizzeriaClosed,
                    schedule: data.schedule,
                    pizzeria_list: data.pizzeria_list,
                    delayThresholdDelivery: data.delayThresholdDelivery,
                    delayThresholdPickup: data.delayThresholdPickup,
                    logo: data.logo,
                    marketplace: data.marketplace
                });

                this.showHandleCloseModal = pizzeriaInfo.hand_close.state;
                component.$store.commit('basket/setPreOrderSchedule', pizzeriaInfo.preOrderSchedule);

                if(pizzeriaInfo.points.length > 0){
                  const closedPizzeriaPoints = pizzeriaInfo.hand_close.points;
                  const pizzeriaActivePoints = component.closePickupOrderType ? pizzeriaInfo.points.filter(p => {
                    return closedPizzeriaPoints.filter(cp => {return cp.ID === p.id; }).length === 0;
                  }) : pizzeriaInfo.points;
                  if(pizzeriaActivePoints.length){
                    this.$store.commit('order/setPizzeriaPointId', pizzeriaActivePoints[0].id);
                  }
                }

                if(isPizzeriaClosed){
                    this.$store.dispatch({
                        type: 'order/changeOrderType',
                        isDeferOrder: true,
                    });
                }

                const filters = data.filters;
                const catalog = data.catalog;
                component.$store.dispatch({
                    type: 'catalog/setCatalogData',
                    catalog: {
                        products: catalog.products,
                        groups: catalog.category,
                        sauce_modifiers: catalog.sauce_modifiers,
                        sauces: catalog.sauces,
                        attributes: catalog.attributes,
                        votes: catalog.votes,
                        filters: filters,
                        stop_list: catalog.stop_list,
                        combos: data.combos
                    },
                });
                component.$store.commit('catalog/setProductShares', catalog.product_shares);
                component.$store.commit('app/setFreeDeliveryShareCondition',
                    data.free_delivery_share_condition);

                component.process_loading = false;
                component.$store.dispatch({
                  type: 'order/loadBasket',
                  products: component.$store.getters['catalog/getProducts']
                }).then(() => {
                  component.activateCouponFromUrl(component.$route.hash);
                  component.applyComboFromRequest(component.$route.query, data.combos);
                  component.calculateDiscount();
                });
                component.updateSessionId(response.headers.session_id);

                if(data.mobile_app_banner !== undefined && data.mobile_app_banner !== null){
                    component.mobileAppBanner = data.mobile_app_banner;
                    setTimeout(() => {
                      component.$store.commit('app/setShowMobileAppBanner', true);
                    }, 3000);
                }
            }).finally(async function () {
              setTimeout(function(){
                const fullPath = component.$route.fullPath;
                const anchor = fullPath.substring(fullPath.indexOf("#"));
                try {
                  if (anchor !== undefined && anchor.length > 0) {
                    scrollerTo(anchor);
                  }
                } catch (err){
                  console.log("Error to scroll to element ", anchor);
                }
              }, 100);

              await component.completeOrderWithOnlinePayment().catch(error => {
                console.error('Error complete order', error);
              });

              const order = component.$cookies.get('order');
              if (order !== undefined && order !== null) {
                const order_id = order.id;
                if (order_id !== undefined) {
                  component.setConfirm();
                  component.$store.dispatch({
                    type: 'order/loadOrderInfo',
                    order: {'id': order_id},
                  });
                  component.checkOrderStatus(order_id, order.payment_id);
                }
              }
            });

            window.addEventListener('focus', function() {
                const order_id = component.order.id;
                const payment_id = component.order.payment_id;
                if(order_id !== undefined && order_id !== null){
                    component.checkOrderStatus(order_id, payment_id);
                }
            });

            this.setDeviceSize();
            window.addEventListener('resize', function() {
                component.setDeviceSize();
            });

            setInterval(function(){
              component.$store.commit('app/setTime', {now: new Date().getTime()});
            }, 1000);
        },
        computed: {
          ...mapGetters('catalog', {
              products: 'getProducts',
              productShare: 'getProductShare',
              isOpenShareModal: 'isOpenShareModal',
          }),
          ...mapGetters('order', {
              isBasketOpen: 'isBasketOpen',
              order: 'getOrderInfo',
          }),
          ...mapGetters('app', {
              isOpenFilter: 'isOpenFilter',
              isShowingCabinet: 'getShowingCabinet',
              pizzeriaInfo: 'getPizzeriaInfo',
              isPizzeriaClose: 'getIsPizzeriaClosed',
              changeLocation: 'getChangeLocation',
              pizzeria_list: 'getPizzeriaList',
              showModalFreeDeliveryShareCondition: 'getShowModalFreeDeliveryShareCondition',
              free_delivery_share_condition: 'getFreeDeliveryShareCondition',
              isDevMode: 'getIsDevMode',
              showMobileAppBanner: 'getShowMobileAppBanner'
          }),
          showPizzaCloseModal: function(){
              return (this.isPizzeriaClose && this.showModalPizzaClosed);
          },
        },
        mixins: [Utils, ComboUtils],
        components:{
            MobileAppBanner,
            Cabinet,
            Footer,
            Header,
            Catalog,
            Basket,
            Logo,
            Map,
            Modal,
            ModalTemplate
        }
    }
</script>

<style scoped lang="scss">
    .error-box{
        margin: 0 auto;
        max-width: 600px;
    }

    .button-close{
        padding: 0.5rem 1rem;
        cursor: pointer;
        text-align: center;
        border: 0.125rem solid #000;
        display: inline-block;
        margin: 0 auto;
        margin-top: 1.5rem;
        border-radius: 0.125rem;
        font-size: 1.25rem;
        line-height: 1.5rem;
    }

    .modal-change-location {
      .location-city {
        color: #fff;
        &:hover {
          background-color: rgba(255, 255, 255, 0.5);
          color: #000;
        }
      }
    }
</style>
